
const digest = 'ac7259fd83ee1dfe2032fb2533ae007883cf2bb4d4c9c2895b12150a58446691';
const classes = {"wrapper":"_wrapper_uwiqv_1","title":"_title_uwiqv_9","content":"_content_uwiqv_14","price":"_price_uwiqv_18","stock":"_stock_uwiqv_23","inStock":"_inStock_uwiqv_27","outOfStock":"_outOfStock_uwiqv_30"};
const css = `._wrapper_uwiqv_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
._wrapper_uwiqv_1 ._title_uwiqv_9 {
  font-weight: 600;
  font-size: 16px;
  color: #3c3f9c;
}
._wrapper_uwiqv_1 ._content_uwiqv_14 {
  display: flex;
  gap: 18px;
}
._wrapper_uwiqv_1 ._content_uwiqv_14 ._price_uwiqv_18 {
  font-weight: 600;
  font-size: 16px;
  color: #3c3f9c;
}
._wrapper_uwiqv_1 ._content_uwiqv_14 ._stock_uwiqv_23 {
  display: flex;
  gap: 5px;
}
._wrapper_uwiqv_1 ._content_uwiqv_14 ._stock_uwiqv_23 ._inStock_uwiqv_27 {
  color: green;
}
._wrapper_uwiqv_1 ._content_uwiqv_14 ._stock_uwiqv_23 ._outOfStock_uwiqv_30 {
  color: red;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  